import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import { UserProvider } from "../../context/UserContext";
// import { useAdminContext } from "../../context/admin/AdminContext";
// import { Navigate } from "react-router-dom";

// Redirect to home
// const ReturnHome = () => {
//   const { sysAdmin } = useAdminContext();
//   if (sysAdmin.role !== "admin")
//     return (
//       <Navigate
//         replace
//         to="/"
//       />
//     );
//   else return null;
// };

export const User = () => {
  return (
    <UserProvider>
      {/* <ReturnHome />; */}
      <Overview />
    </UserProvider>
  );
};

export const AddUser = () => {
  return (
    <UserProvider>
      {/* <ReturnHome />; */}
      <Add />
    </UserProvider>
  );
};

export const EditUser = () => {
  return (
    <UserProvider>
      {/* <ReturnHome />; */}
      <Edit />
    </UserProvider>
  );
};
